import { render } from "./PoliticsPage.vue?vue&type=template&id=1e91fa9c&scoped=true"
import script from "./PoliticsPage.vue?vue&type=script&lang=js"
export * from "./PoliticsPage.vue?vue&type=script&lang=js"

import "./PoliticsPage.vue?vue&type=style&index=0&id=1e91fa9c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e91fa9c"]])

export default __exports__